import {
  Box,
  Container,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { AddPushNotificationModal, HeaderWithButtons, Searchbar } from "../components-molecules";
import { Add } from '@material-ui/icons';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPushNotifications } from '../redux/actions/pushNotifications';
import { getshopNames } from '../redux/actions/getShopNames';
import { IShopByMerchantResponse } from '../redux/reducers/getShopNames';
import { PushNotificationList } from '../components-organisms/PushNotificationList';
import { debounce } from 'lodash';
import { ButtonPrimary } from "../components-atoms";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { useTranslation } from 'react-i18next';

export const PushNotifications = (props: any) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const timeoutDuration = 1500;
  const [modal, setModal] = useState<string>('');
  const [searchOpen, setSearchOpen] = useState<boolean>(false);
  const [query, setQuery] = useState<string>('');
  const dispatch = useDispatch();
  const list: IShopByMerchantResponse[] = useSelector((state: any) => state.GetShopNamesReducer.data);
  const getNotifications = useCallback(() => {
    dispatch(getPushNotifications({ Query: query }));
  }, [dispatch, query]);

  useEffect(() => {
    dispatch(getshopNames());
  }, [dispatch]);
  useEffect(() => {
    getNotifications();
  }, [query, getNotifications]);


  return (
    <Box className={classes.container}>
      <CssBaseline />
      <Container className={classes.root}>
        <CssBaseline />
        <HeaderWithButtons title={t('admin.pushNotifications')}>
          <HeaderWithButtons.ButtonArea>
            <div className={classes.buttonSet}>
              <IconButton
                data-automation="search-button"
                className={classes.searchIconButton}
                color='primary'
                onClick={() => setSearchOpen(!searchOpen)}
              >
                <SearchRoundedIcon
                  color='primary'
                  className={classes.searchIcon}
                />
              </IconButton>
              <ButtonPrimary
                data-automation="add-code-button"
                style={{
                  paddingLeft: props.loading ? "12px" : "16px",
                }}
                className={classes.primaryButton}
                startIcon={<Add />}
                onClick={() => setModal('add')}>
                Send
              </ButtonPrimary>
            </div>
          </HeaderWithButtons.ButtonArea>
        </HeaderWithButtons>
        <Searchbar
          isOpen={searchOpen}
          query={query}
          placeholder="Search Notifications"
          onCancel={() => { setSearchOpen(false); setQuery(''); }}
          onChange={event => debounce((e) => setQuery(e.target.value), timeoutDuration)(event)}
        />
        <PushNotificationList query={query} list={list} />
      </Container>
      {list?.length > 0 &&
        <AddPushNotificationModal
          shops={list as any}
          visible={modal === 'add'}
          onClose={() => {
            setModal('');
          }}
        />
      }
    </Box>
  );
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
  },
  root: {
    maxWidth: "840px",
    paddingLeft: 0,
    paddingRight: 0,
  },
  buttonSet: {
    display: "flex",
    flexDirection: "row",
    paddingRight: "24px",
  },
  primaryButton: {
    marginLeft: 16,
    borderRadius: 8,
  },
  searchIcon: {
    width: 24,
    height: 24,
  },
  searchIconButton: {
    width: 40,
    height: 40,
    marginLeft: 8,
    ...textButtonHoverAndActive
  }
});

